import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-refresh.tsx
/**
* icon.24.refresh
*
* Keywords: circular, arrows, rotation, cycle, clockwise, reload, sync, update
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjUyMyAxMi4wMzZhLjUuNSAwIDAgMSAuNDQ5LjU0NkE1Ljk5OSA1Ljk5OSAwIDAgMSA3IDE1LjMxNVYxNy41YS41LjUgMCAwIDEtMSAwdi0zYS41LjUgMCAwIDEgLjUtLjVoM2EuNS41IDAgMCAxIDAgMUg4LjAwMnEuMDY2LjA4OS4xMzcuMTc1YTUgNSAwIDAgMCA4LjgzOC0yLjY5LjUuNSAwIDAgMSAuNTQ2LS40NU0xNy41IDZhLjUuNSAwIDAgMSAuNS41djNhLjUuNSAwIDAgMS0uNS41aC0zYS41LjUgMCAwIDEgMC0xaDEuNDk4YTUgNSAwIDAgMC04Ljk3NSAyLjUxNS41LjUgMCAxIDEtLjk5NS0uMDk3QTYgNiAwIDAgMSAxNyA4LjY4NFY2LjVhLjUuNSAwIDAgMSAuNS0uNSIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=1-1304
*/
const Icon24Refresh = memo(function Icon24Refresh(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.523 12.036a.5.5 0 0 1 .449.546A5.999 5.999 0 0 1 7 15.315V17.5a.5.5 0 0 1-1 0v-3a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1H8.002q.066.089.137.175a5 5 0 0 0 8.838-2.69.5.5 0 0 1 .546-.45M17.5 6a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h1.498a5 5 0 0 0-8.975 2.515.5.5 0 1 1-.995-.097A6 6 0 0 1 17 8.684V6.5a.5.5 0 0 1 .5-.5"
		})
	});
});
//#endregion
export { Icon24Refresh };

//# sourceMappingURL=icon-24-refresh.js.map